import React from "react";
import { LoadingWrapper } from "./styled";

function Loading(props) {
  return <LoadingWrapper>Loading...</LoadingWrapper>;
}

export default Loading;
